import React from 'react';
import {
  Heading1, Paragraph, List, Heading2, Heading4,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import RowProductView from '../components/grid/RowProductView';
import ProductView1 from '../components/commerce/ProductViews/ProductView1';
import SidemenuLayout from '../layout/DefaultLayout/Layouts/SidemenuLayout';
import { ItemTraverser } from '../containers/commerce';

export default () => (
  <SidemenuLayout menuPicker="VandSodavand" activeSidemenu="Cocio">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1 margin="0 0 10px">
            Cocio kakaomælk
          </Heading1>
          <Paragraph>
            Cocio blev grundlagt i 1951 og vandt hurtigt indpas hos danskerne - og er sidenhen blevet en ren favorit. Cocio kakaomælk blev indbegrebet af den danske pølsevognskultur, da lovgivningen ikke tillod pølsevogne at sælge kulsyreholdige drikke. I stedet er det blevet en tradition i Danmark, at man drikker en Cocio kakao til sin pølse eller hotdog.
          </Paragraph>
          <Paragraph>
            Vi sælger flere varianter fra Europas førende producent af chokolademælk - Cocio.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="cocio" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Cocio - danskernes darling
          </Heading2>
          <Paragraph>
            Cocio er mere end bare en kakaomælk - det er en ikonisk dansk favorit, som har vundet danskernes hjerter i generationer. Med sin rige og fyldige smag er Cocio blevet symbolet på den ultimative kakaomælksoplevelse. Men hvad er det, der gør Cocio så elsket blandt danskerne?
          </Paragraph>
          <Paragraph>
            For det første, er det vigtigt at nævne den autentiske smag, som er kendetegnende for Cocio. Denne kakaomælk er lavet af de fineste ingredienser, herunder premium kakao og frisk mælk. Resultatet er en fyldig og cremet smag, der er fuld af chokoladearoma og sødme. Danskerne har simpelthen forelsket sig i denne lækre og tilfredsstillende smag, som de har nydt og værdsat gennem årene.
          </Paragraph>
          <Paragraph>
            Cocio er også blevet et symbol på dansk hygge og nostalgi. Mange danskere forbinder Cocio kakao med barndommens glæder og minder om afslappende stunder derhjemme eller på caféer. Denne kakaomælk er blevet en fast del af danskernes kulturelle identitet og en kilde til komfort og velvære. Uanset om det er en kold vinterdag eller en lun sommeraften, kan danskerne altid regne med Cocio for at tilføje en følelse af hygge og velbehag.
          </Paragraph>
          <Paragraph>
            Cocio er ikke bare en almindelig kakaomælk - det er en dansk nationalstolthed. Med sin autentiske smag, hyggelige associationer og fokus på kvalitet har Cocio kakaomælk formået at erobre danskernes hjerter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Cocio kakao i flere størrelser
          </Heading2>
          <Paragraph>
            Hos Skafte kan du sikre dig, at du altid har en lækker og cremet Cocio kakaomælk på lager - uanset om det er til hjemmet eller arbejdspladsen. Du kan endda vælge mellem flere forskellige størrelser og om det skal være Cocio på dåse eller den klassiske glasflaske.
          </Paragraph>
          <Paragraph>
            Vælg mellem Cocio i følgende størrelser:
          </Paragraph>
          <List>
            <li>Cocio på glasflaske med 24 cl</li>
            <li>Cocio dåse med 25 cl</li>
            <li>Cocio på flaske med 40 cl</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Hemmeligheden bag den gode og velkendte Cocio smag</Heading2>
          <Paragraph>
            Ind fra siden kommer der frisk mælk, det bedste kakao fra Elfenbenskysten og ganske almindeligt sukker. Ud i den anden ende kommer den velkendte Cocio, som alle danskerne elsker.
          </Paragraph>
          <Paragraph>
            Det er den korte version, og medmindre du er meget interesseret i teknik, opskrifter, produktionsgange og anden industrisnak, så behøver du ikke læse mere. For os andre er der sjove detaljer i vente...
          </Paragraph>
        </Col>
        <Col xs={12}>
          <Heading4>Helt vildt effektivt</Heading4>
          <Paragraph>
            Cocio laves i Esbjerg på en ny fabrik, der hver dag sender 400.000 flasker Cocio kakao ud i verden. Dét er da en del.
          </Paragraph>
          <Paragraph>
            Produktionen foregår på to fleksible linjer, der kan høvle mellem 28.000 og 30.000 flasker igennem i timen.
          </Paragraph>
        </Col>
        <Col xs={12}>
          <Heading4>Miljø og ansvarlighed er godt</Heading4>
          <Paragraph>
            Naturligvis kører Cocio fabrikken efter de nyeste miljø- og energibevidste teknologier og arbejdsprocesser. Og så er Cocio selvforsynende med varme - overskudsvarmen fra produktionen får nemlig ikke lov at gå til spilde. Fabrikken ligger jo trods alt i Esbjerg!
          </Paragraph>
        </Col>
        <Col xs={12}>
          <Heading4>Sådan sker det (her kommer hemmeligheden!)</Heading4>
          <Paragraph>
            Cocio kakaomælk består udelukkende af mælk, kakao og sukker. Intet andet! Det er gennem forarbejdningen af disse tre ingredienser, at den helt særlige Cocio smag opstår.
          </Paragraph>
          <Paragraph>
            Enkelt fortalt, så blandes ingredienserne og sendes gennem et rørsystem videre til tappehallen, hvor rå-Cocio&apos;en hældes på flaske og kapsles. Herefter sendes flaskerne til kogning ved en hemmelig temperatur. Det er denne kogning, der gør, at Cocio kakao får sin helt unikke smag, for under den helt rigtige temperatur begynder sukkeret, mælkesukkeret og kakaoen at snakke rigtig godt sammen - de karamelliserer og den store og runde smag af chokolade opstår. Det lyder enkelt, men der er endnu ingen, der har kunnet finde ud af at efterligne smagen af en original Cocio kakaomælk!
          </Paragraph>
          <Paragraph>
            Efter kogningen bliver Cocio flaskerne stillet til side i 5 dage. Chokolademælken skal modnes, så at sige. Den helt rigtige smag skal lige have lidt tid til at udvikle sig. Enhver vil kunne smage forskel på en helt ny Cocio og en modnet Cocio.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
